<div class="body-wrapper" *ngIf="print.loaded" [ngClass]="Direction" style='padding-top: 0;'>
    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader"></div>
        <div class="justify-between items-center" *ngIf="print.env && print.env['haslogo'] && ! altHeader">
            <img style="width: 100%;" [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo">
        </div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title" style="max-width: 100%; font-size: 28px; white-space: normal; overflow-wrap: break-word;">
                {{print.exam.Changed ? print.exam.ChangedExamTitle : (('exam.type.genus.' + (print.exam.SubExamType ? print.exam.SubExamType : print.exam.ExamType)) | translate)}}
                <span *ngIf="print.exam?.Draft">
                    ({{( 'general.DraftPrint') | translate}})
                </span>
            </h1>
            <!-- <img [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo"
                class="header-logo" *ngIf="print.env && ! altHeader && print.env['haslogo']"> -->
        </div>
        <div class="header-details" style="margin-bottom: 3em;">
            <div style="display: inline-block; padding-left: 1em;padding-right: 1em;font-size: 12pt;">{{(print.isForm ? 'general.date'
                :'general.ExaminationDate')| translate}}:&nbsp;<strong style='direction: ltr;'>{{print.exam.CreationTime
                    | date:"dd.MM.yyyy"}}</strong></div>
            <div style="display: inline-block;font-size: 12pt">
                {{'general.Printing_Date' | translate}}:&nbsp;
                <strong style='direction: ltr;'>
                    {{now | date:"dd.MM.yyyy HH:mm"}}
                </strong>
            </div>
        </div>
    </header>
    <main class="main" [ngClass]="typeOfPrint">
        <section class="section" *ngIf="print.Pat">
            <h4 class="text-20 text-gold">{{(print.Pat.Sex ? (print.Pat.Sex == 'M' ?  'gastro.Patient.male' : 'gastro.Patient.female'): 'gastro.Patient.details') | translate}}</h4>
            <div style="width:100%">
                <div>
                    <table>
                        <tr>
                            <td>
                                <dt>{{'general.Patient.first_name' | translate}}</dt>
                                <dd>{{print.Pat.First}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.last_name' | translate}}</dt>
                                <dd>{{print.Pat.Last}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.ID' | translate}}</dt>
                                <dd>{{print.Pat.ID}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Mobile">
                                <dt>{{'general.Patient.mobile' | translate}}</dt>
                                <dd>{{print.Pat.Mobile}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Sex">
                                <dt>מגדר</dt>
                                <dd>{{print.Pat.Sex == 'M'? 'גבר': 'אישה' }}</dd>
                            </td>
                        </tr>
                        <tr *ngIf="print.Pat.Height || print.Pat.Weight">
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.birth_date' | translate}}</dt>
                                <dd>{{print.Pat.Birth| date:"dd.MM.yyyy"}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.Age' | translate}}</dt>
                                <dd>{{print.Pat.getAgeMo()}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Height">
                                <dt>גובה</dt>
                                <dd>{{print.Pat.Height}}cm</dd>
                            </td>
                            <td *ngIf="print.Pat.Weight">
                                <dt>משקל</dt>
                                <dd>{{print.Pat.Weight}}kg</dd>
                            </td>
                        </tr>
                    </table>

                    
                </div>
            </div>
        </section>
        
     
    <ng-container *ngIf="print.usGeneral && print.usGeneral[0] && print.es.ExamType === 'Abdomen US'">
        <section class="section">
            <section class="section" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].MedicalHistory}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].ReasonExamination}}
                </div>
            </section>
        </section>
        <section class="section">
            <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate }}</h4>
    
            <section class="section" *ngIf=" print.usGeneral[0].Liver">
                <h4>{{'gastro.abdomen.Liver' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Liver}}
                </div>
            </section>
            <section class="section" *ngIf=" print.usGeneral[0].Gallbladder">
                <h4>{{'gastro.abdomen.Gallbladder' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Gallbladder}}
                </div>
            </section>
            <section class="section" *ngIf=" print.usGeneral[0].BiliaryTract">
                <h4>{{'gastro.abdomen.BiliaryTract' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].BiliaryTract}}
                </div>
            </section>
            <section class="section" *ngIf=" print.usGeneral[0].Pancreas">
                <h4>{{'gastro.abdomen.Pancreas' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Pancreas}}
                </div>
            </section>
            <section class="section" *ngIf=" print.usGeneral[0].Intestine">
                <h4>{{'gastro.abdomen.Intestine' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Intestine}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].RetroPeritoneum">
                <h4>{{'gastro.abdomen.RetroPeritoneum' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].RetroPeritoneum}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].Spleen">
                <h4>{{'gastro.abdomen.Spleen' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Spleen}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].AbdominalAorta">
                <h4>{{'gastro.abdomen.AbdominalAorta' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].AbdominalAorta}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].Kidneys">
                <h4>{{'gastro.abdomen.Kidneys' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Kidneys}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].Bladder">
                <h4>{{'gastro.abdomen.Bladder' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Bladder}}
                </div>
            </section>
            <section class="section" *ngIf="print.usGeneral[0].Prostate">
                <h4>{{'gastro.abdomen.Prostate' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Prostate}}
                </div>
            </section>

        </section>
        <!-- Diagnosis (GUS-88 catalogue) -->
        <section class="section" *ngIf="print.hasExamDiagnoses() && (print.es.ExamType === 'Abdomen US' || print.es.ExamType === 'Colonoscopy' || print.es.ExamType === 'Gastroscopy' || print.es.ExamType === 'Sigmoidoscopy')">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <section class="section" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;">
                </span>
            </div>

        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>

    </ng-container>

    <!-- =============== MSK Musculoskeletal Exam (Start) =============== -->
    <ng-container *ngIf="print.usGeneral && print.usGeneral[0] && print.es.ExamType === 'MSK Musculoskeletal'">
        <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory || print.usGeneral[0].ReasonExamination"> 
            <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].MedicalHistory}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].ReasonExamination}}
                </div>
            </section>
        </section>
        <section class="section">
            <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate }}</h4>
    
            <section class="section no-page-break" *ngIf="print.usGeneral[0].NeckandSoftTissues">
                <h4>{{'genus.NeckandSoftTissues' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].NeckandSoftTissues}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ShoulderRight || print.usGeneral[0].ShoulderLeft">
                <h4>{{'genus.Shoulder' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].ShoulderRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].ShoulderRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].ShoulderLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].ShoulderLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ElbowRight || print.usGeneral[0].ElbowLeft">
                <h4>{{'genus.Elbow' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].ElbowRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].ElbowRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].ElbowLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].ElbowLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].WristRight || print.usGeneral[0].WristLeft">
                <h4>{{'genus.Wrist' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].WristRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].WristRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].WristLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].WristLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].HandRight || print.usGeneral[0].HandLeft">
                <h4>{{'genus.Hand' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].HandRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].HandRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].HandLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].HandLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Pelvic">
                <h4>{{'genus.Pelvic' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].Pelvic}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].KneeRight || print.usGeneral[0].KneeLeft">
                <h4>{{'genus.Knee' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].KneeRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].KneeRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].KneeLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].KneeLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].AnkleRight || print.usGeneral[0].AnkleLeft">
                <h4>{{'genus.Ankle' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].AnkleRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].AnkleRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].AnkleLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].AnkleLeft}}
                </div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].FootRight || print.usGeneral[0].FootLeft">
                <h4>{{'genus.Foot' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].FootRight" style="white-space: pre-wrap; margin-bottom: 1em;">
                    <strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].FootRight}}
                </div>
                <br>
                <div *ngIf="print.usGeneral[0].FootLeft" style="white-space: pre-wrap;">
                    <strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].FootLeft}}
                </div>
            </section>

        </section>
        <section class="section no-page-break" *ngIf="print.hasExamDiagnoses()">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;">
                </span>
            </div>

        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>

    </ng-container>
    <!-- =============== MSK Musculoskeletal Exam (End) =============== -->

    <!-- =============== MSK & Soft Tissues Exam (Start) =============== -->
    <ng-container *ngIf="print.usGeneral && print.usGeneral[0] && print.es.ExamType === 'MSK & Soft Tissues'">
        <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory || print.usGeneral[0].ReasonExamination">
            <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].MedicalHistory}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].ReasonExamination}}</div>
            </section>
        </section>
        <section class="section" *ngIf="print.usGeneral[0].ChestWallAndBack || print.usGeneral[0].AbdominalWallAndGroins || print.usGeneral[0].ShoulderLeft || print.usGeneral[0].ShoulderRight || print.usGeneral[0].ElbowLeft || print.usGeneral[0].ElbowRight || print.usGeneral[0].WristLeft || print.usGeneral[0].WristRight || print.usGeneral[0].HandLeft || print.usGeneral[0].HandRight || print.usGeneral[0].Pelvic || print.usGeneral[0].KneeLeft || print.usGeneral[0].KneeRight || print.usGeneral[0].AnkleLeft || print.usGeneral[0].AnkleRight || print.usGeneral[0].FootLeft || print.usGeneral[0].FootRight">
            <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate }}</h4>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ChestWallAndBack">
                <h4>{{'genus.ChestWallAndBack' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].ChestWallAndBack}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].AbdominalWallAndGroins">
                <h4>{{'genus.AbdominalWallAndGroins' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].AbdominalWallAndGroins}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ShoulderRight || print.usGeneral[0].ShoulderLeft">
                <h4>{{'genus.Shoulder' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].ShoulderLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].ShoulderLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].ShoulderRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].ShoulderRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ElbowRight || print.usGeneral[0].ElbowLeft">
                <h4>{{'genus.Elbow' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].ElbowLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].ElbowLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].ElbowRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].ElbowRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].WristRight || print.usGeneral[0].WristLeft">
                <h4>{{'genus.Wrist' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].WristLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].WristLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].WristRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].WristRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].HandRight || print.usGeneral[0].HandLeft">
                <h4>{{'genus.Hand' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].HandLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].HandLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].HandRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].HandRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Pelvic">
                <h4>{{'genus.Pelvic' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Pelvic}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].KneeRight || print.usGeneral[0].KneeLeft">
                <h4>{{'genus.Knee' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].KneeLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].KneeLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].KneeRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].KneeRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].AnkleRight || print.usGeneral[0].AnkleLeft">
                <h4>{{'genus.Ankle' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].AnkleLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].AnkleLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].AnkleRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].AnkleRight}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].FootRight || print.usGeneral[0].FootLeft">
                <h4>{{'genus.Foot' | translate}}</h4>
                <div *ngIf="print.usGeneral[0].FootLeft" style="white-space: pre-wrap; margin-bottom: 1em;"><strong>{{'general.Left' | translate}}:</strong>{{print.usGeneral[0].FootLeft}}</div>
                <br>
                <div *ngIf="print.usGeneral[0].FootRight" style="white-space: pre-wrap;"><strong>{{'general.Right' | translate}}:</strong>{{print.usGeneral[0].FootRight}}</div>
            </section>
        </section>
        <section class="section no-page-break" *ngIf="print.hasExamDiagnoses()">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;"></span>
            </div>
        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>
    </ng-container>
    <!-- =============== MSK & Soft Tissues Exam (End) =============== -->

    <!-- =============== Neck scan Exam (Start) =============== -->
    <ng-container *ngIf="print.usGeneral && print.usGeneral[0] && print.es.ExamType === 'Neck scan'">
        <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory || print.usGeneral[0].ReasonExamination">
            <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].MedicalHistory}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].ReasonExamination}}</div>
            </section>
        </section>
        <section class="section" *ngIf="print.usGeneral[0].NeckandSoftTissues || print.usGeneral[0].Thyroid || print.usGeneral[0].SalivaryGlands || print.usGeneral[0].Parotid || print.usGeneral[0].LymphNodes || print.usGeneral[0].BloodVessels">
            <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate }}</h4>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].NeckandSoftTissues">
                <h4>{{'genus.Neck' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].NeckandSoftTissues}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Thyroid">
                <h4>{{'genus.Thyroid' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Thyroid}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].SalivaryGlands">
                <h4>{{'genus.SalivaryGlands' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].SalivaryGlands}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Parotid">
                <h4>{{'genus.Parotid' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Parotid}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].LymphNodes">
                <h4>{{'genus.LymphNodes' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].LymphNodes}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].BloodVessels">
                <h4>{{'genus.BloodVessels' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].BloodVessels}}</div>
            </section>
        </section>
        <section class="section no-page-break" *ngIf="print.hasExamDiagnoses()">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;"></span>
            </div>
        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>
    </ng-container>
    <!-- =============== Neck scan Exam (End) =============== -->

    <!-- =============== Ultrasound Scan Summary (Start) =============== -->
    <ng-container *ngIf="print.usGeneral && print.usGeneral[0] && print.es.ExamType === 'Ultrasound Scan Summary'">
      
            <section class="section" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].MedicalHistory}}
                </div>
            </section>
         <section class="section no-page-break" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].ReasonExamination}}
                </div>
            </section>

            <section class="section" *ngIf="print.usGeneral[0].ProbeType">
                <h2>{{'genus.ProbeType' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.usGeneral[0].ProbeType}}
                </div>
            </section>

            <section class="section" *ngIf="print.usGeneral[0].ImagingQuality">
                <h2>{{'summary.ImagingQuality.title' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{ ('summary.ImagingQuality.' + print.usGeneral[0].ImagingQuality) | translate }}
                </div>
            </section>
        
        <section class="section no-page-break" *ngIf="print.hasExamDiagnoses()">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;">
                </span>
            </div>

        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>

        <!-- Referring Doctor -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].ReffDoc">
            <h4>{{'general.Patient.referring_doctor' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].ReffDoc}}</div>
        </section>
    </ng-container>
    <!-- =============== Ultrasound Scan Summary (End) =============== -->

  
    <!-- =============== Exam Signature (Start) =============== -->
    <ng-container
      *ngIf="!print.exam.Draft && print.exam.SignedBy && print.exam.SignedDate"
    >
      <section class="section">
        <table *ngIf="print.signers">
          <tr *ngFor="let s of print.signers">
            <td *ngIf="s.Membership == 'tech'">
              <strong>{{ "general.Tech" | translate }}: </strong>
              {{ s.OpenerName }}
              <span *ngIf="s.TechNum"> <strong>{{ "summary.doctor.licensenumber" | translate }}</strong> {{ s.TechNum }}</span>
            </td>
            <td *ngIf="s.Membership == 'nurse'">
              <strong>{{ "GUI.Patient History.Done by" | translate }}: </strong>
              {{ s.OpenerName }}
              <span *ngIf="s.NurseNum"> <strong>{{ "summary.doctor.licensenumber" | translate }}</strong> {{ s.NurseNum }}</span>
            </td>
          </tr>
        </table>
        <div style="margin-top: 1em">
          <strong>
            {{ "cardio.summary.signExam" | translate }}
        </strong>
          {{ print.exam.SignedBy }}
          {{ "cardio.summary.at" | translate }}
          {{ print.exam.SignedDate | date: "dd.MM.yyyy HH:mm" }}
          <ng-container *ngIf="print.exam.license">
            <strong>מ.ר.</strong>
            {{ print.exam.license }}
            </ng-container
          >
          <ng-container *ngIf="print.exam.ExpertNum">
            <strong>מ.ר.מ.</strong>
            {{ print.exam.ExpertNum }}
            </ng-container
          >
        </div>
      </section>
    </ng-container>
    <!-- =============== Exam Signature (End) =============== -->

        <div *ngIf="hasImages && print.images.length > 0" class="signatures" [ngClass]="'perpage'+imPerPage">
            <ng-container *ngFor="let image of print.images">
                <div style="width: fit-content;display: inline-flex;flex-direction: column;">
                    <img style="padding: 0.5em;" [src]="'/api/getmedia/'+image.src+'/n'">
                    <p *ngIf="image.text" class="section" style="width: 95%;margin-inline-start: 0.5em;" [ngClass]="imPerPage ==2 ? 'w100' :'w95'">{{image.text}}</p>
                </div>
            </ng-container>
        </div>
        <span class="comment" class="finished" *ngIf="loaded"></span>
    </main>
</div>